import { useTheme } from '@mui/material'
import { useOnboarding } from '@src/providers/OnboardingProvider'
import type { JSX } from 'react'
import { ACTIONS, EVENTS, Joyride, STATUS, type EventData } from 'react-joyride'
import TourTooltip from './TourTooltip'

const OnboardingTour = (): JSX.Element => {
  const { isTourActive, stepIndex, steps, stopTour, setStepIndex } = useOnboarding()
  const theme = useTheme()

  const handleEvent = (data: EventData) => {
    const { action, index, status, type } = data

    if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
      stopTour()
      return
    }

    if (action === ACTIONS.CLOSE || action === ACTIONS.SKIP) {
      stopTour()
      return
    }

    if (type === EVENTS.STEP_AFTER) {
      if (action === ACTIONS.NEXT) {
        setStepIndex(index + 1)
      } else if (action === ACTIONS.PREV) {
        setStepIndex(index - 1)
      }
      return
    }

    if (type === EVENTS.TARGET_NOT_FOUND) {
      setStepIndex(index + 1)
    }
  }

  return (
    <Joyride
      run={isTourActive}
      continuous
      steps={steps}
      stepIndex={stepIndex}
      onEvent={handleEvent}
      tooltipComponent={TourTooltip}
      options={{
        skipBeacon: true,
        disableFocusTrap: true,
        buttons: ['back', 'skip', 'primary'],
        overlayColor: 'rgba(0, 0, 0, 0.5)',
        overlayClickAction: false,
        dismissKeyAction: false,
        blockTargetInteraction: true,
        primaryColor: theme.palette.primary.main,
        zIndex: theme.zIndex.modal + 10,
        targetWaitTimeout: 4000,
      }}
      scrollToFirstStep
    />
  )
}

export default OnboardingTour
